export interface PickByClientOptions {
  DEFAULT: string;
  DEV?: string | undefined;
  TST?: string | undefined;
}

export const pickByClient = (clientAbbrev: string | undefined | null, opts: PickByClientOptions): string => {
  if (clientAbbrev === 'DEV') {
    return opts.DEV || opts.DEFAULT;
  }
  if (clientAbbrev === 'TST') {
    return opts.TST || opts.DEFAULT;
  }
  return opts.DEFAULT;
};

export default pickByClient;
